<template>
  <div class="signin-card">
    <img v-if="logo" class="signin-logo" :src="logo" alt="iCare Connect" />
    <div v-if="screen==='signin'" class="signin-body">
      <h4>Sign in</h4>
      <p class="signin-hint">Use the email and password for your organization.</p>
      <b-form @submit.prevent="signIn">
        <input class="signin-field" v-model="user.email" placeholder="Email" type="email" required autocomplete="username" />
        <input class="signin-field" v-model="user.password" placeholder="Password" type="password" required autocomplete="current-password" />
        <b-form-input v-if="askSignupCode" v-model="user.signupCode" placeholder="Signup code" type="text" />
        <label class="signin-remember">
          <input type="checkbox" v-model="user.rememberMe" />
          <span>Remember me</span>
        </label>
        <div class="signin-help">
          <b-link @click="setScreen('forgot-password')">Forgot password</b-link>
        </div>
        <b-button type="submit" class="signin-submit">Sign In</b-button>
      </b-form>
      <!--
        Register-for-access is parked until invitation tokens are ready.
        iCare Connect must link a portal login to an existing iCare account,
        not create a new account from this page.
      <div class="signin-footer">
        <p>Don't have an account?</p>
        <b-link @click="setScreen('register')">Register for access</b-link>
      </div>
      -->
    </div>
    <div v-if="screen==='forgot-password'" class="signin-body">
      <h4>Forgot Password</h4>
      <b-form autocomplete="nothing-to-see-here-folks" @submit.prevent="changePassword">
        <b-form-input
          style="margin-bottom: 1em;"
          autocomplete="no-auto-complete"
          v-model="user.email"
          placeholder="Email..."
          type="email"
          required
        />

        <label class="signin-check">
          <input type="checkbox" v-model="isHaveCode" />
          <span>I already have a code.</span>
        </label>

        <template v-if="!isHaveCode">
          <b-button class="btn btn-sm btn-success" @click="forgotPassword()">Yep, please send the code</b-button>
        </template>

        <b-form-input
          v-if="isHaveCode"
          class="mb-2"
          v-model="user.resetCode"
          placeholder="XXX-XXX"
          type="text"
          required
        />

        <template v-if="isHaveCode && user.resetCode?.length === 7">
          <hr class="my-4" />
          <b-form-group label="New Password" label-class="font-weight-bold text-start" class="mb-3">
            <b-form-input
              v-model="user.password"
              placeholder="Enter new password"
              type="password"
              required
              class="rounded-pill"
              @input="validatePasswords"
            />
            <small v-if="passwordError && user.password" class="text-danger d-block mt-1">{{ passwordError }}</small>
          </b-form-group>

          <b-form-group label="Confirm Password" label-class="font-weight-bold text-start" class="mb-4">
            <b-form-input
              v-model="user.confirmPassword"
              placeholder="Confirm your password"
              type="password"
              required
              class="rounded-pill"
              @input="validatePasswords"
            />
            <small v-if="confirmPasswordError && user.confirmPassword" class="text-danger d-block mt-1">{{ confirmPasswordError }}</small>
          </b-form-group>

          <b-button
            :disabled="!arePasswordsValid()"
            class="btn btn-success px-4 py-2 rounded-pill"
            @click="changePassword"
          >
            Change Password
          </b-button>
        </template>
      </b-form>

      <div class="signin-footer">
        <p style="padding:0;margin:0;">Already have an account?</p>
        <b-link @click="setScreen('signin')">Back to sign in</b-link>
      </div>
    </div>
    <!--
    <div v-if="screen==='register'" class="signin-body">
      <h4>Register for Access</h4>
      <b-form autocomplete="new-password">
        <b-form-input v-model="user.signupCode" placeholder="Signup Code" type="text" required />
        <b-form-input style="margin-bottom:1em;" v-model="user.email" placeholder="Email..." type="email" required />
      </b-form>
      <b-button class="signin-submit signin-submit--alt" @click="register()">Register for Access</b-button>
      <p class="signin-hint">
        Provide your signup code and email. A registration code will be emailed so you can set your password.
      </p>
      <div class="signin-footer">
        <p>Already have an account?</p>
        <b-link @click="setScreen('signin')">Back to sign in</b-link>
      </div>
    </div>
    -->
  </div>
</template>

<script>

// do the deed here -- too much back and forth otherwise -- AND this makes it an easy control

export default {
  props: {
    logo         : {type: String, default: null},
    initialScreen: {type: String, default: "signin"},
    domain       : {type: String, default: null},
    askSignupCode: {type: Boolean, default: false},
    isHaveCode   : {type: Boolean, default: false }
  },
  created() {
    this.isSignin = this.initialSignin;
  },
  watch: {
    domain(val) {
      this.user.domain = val || "";
      const rootSub = this.$root && typeof this.$root.subDomain === "function" ? this.$root.subDomain() : "";
      this.user.subDomain = val || rootSub || "";
    },
    initialScreen(val) {
      if (val) {
        this.screen = val;
      }
    }
  },
  data() {
    return {
      screen              : this.initialScreen,
      // isHaveCode          : false,
      passwordError       : '',
      confirmPasswordError: '',
      user                : {
        action         : "signin",
        host           : String((this.$root && this.$root.host) || (typeof window !== "undefined" ? window.location.host : "")).replace("https://", "").replace("http://", ""),
        hostUrl        : typeof window !== "undefined" ? window.location.host : "",
        hostName       : typeof window !== "undefined" ? window.location.hostname : "",
        subDomain      : this.domain || (this.$root && typeof this.$root.subDomain === "function" ? this.$root.subDomain() : "") || "",
        domain         : this.domain || "",
        email          : "",
        firstName      : "",
        password       : "",
        confirmPassword: "",
        signupCode     : "",                                                               // only used when required
        rememberMe     : false,
        isNew          : false,
        terms          : false
      }
    };
  },
  computed: {},
  methods : {
    signinValid() {
      if(!this.user.password || (this.user.password !== this.user.confirmPassword)) {
        return false;
      }
      if(!this.user.terms) {
        return false;
      }
      return true;
    },
    isValidPassword(password) {
      if (!password) {
        return "Password is required.";
      }
      if (password.length < 7) {
        return "Password must be at least 7 characters.";
      }
      if (!/[A-Z]/.test(password)) {
        return "Password must contain at least one uppercase letter.";
      }
      if (!/[!@#$%^&*(),.?\":{}|<>]/.test(password)) {
        return "Password must contain at least one special character (e.g., !@#$%^&*).";
      }
      return "";
    },
    validatePasswords() {
      // Validate password (only show error if there's input)
      this.passwordError = this.user.password ? this.isValidPassword(this.user.password) : '';

      // Validate confirm password (only show error if there's input)
      if (this.user.confirmPassword) {
        if (!this.user.password) {
          this.confirmPasswordError = "Please enter a password first.";
        } else if (this.user.password !== this.user.confirmPassword) {
          this.confirmPasswordError = "Passwords do not match.";
        } else {
          this.confirmPasswordError = '';
        }
      } else {
        this.confirmPasswordError = '';
      }
    },
    arePasswordsValid() {
      const isValid = this.user.password &&
                      this.user.confirmPassword &&
                      !this.isValidPassword(this.user.password) &&
                      this.user.password === this.user.confirmPassword;
      // console.log('arePasswordsValid:', isValid, 'pw:', this.user.password, 'confirm:', this.user.confirmPassword);
      return isValid;
    },
    setScreen(name) {
      this.screen = name;
      this.$emit("screen-change", name);
    },
    signIn() {
      this.$emit("signin", this.user);
    },
    // register() {
    //   this.user.isNew  = true;
    //   this.user.action = "register";
    //   this.$emit("register", this.user);
    // },
    changePassword() {
      this.user.action = "change-password";
      this.$emit("change-password" , this.user );
    },
    forgotPassword() {
      this.user.action = "forgot-password";
      this.$emit("forgot-password", this.user);
      this.isHaveCode = true;
    },
    showTerms() {
      this.$emit("showTerms");
    }
  }
};
</script>

<style lang="scss">
.signin-card {
  padding: 0.5rem 0.75rem 1rem;
  text-align: center;
  max-width: 380px;
  width: 100%;
  margin: auto;
}

.signin-card img,
.signin-logo {
  display: block;
  margin: 0 auto 1.15rem;
  max-width: 252px;
  width: 100%;
  height: auto;
}

.signin-body {
  margin: 0.5rem 0 0;

  h4 {
    color: #1b1712;
    font-family: var(--font-display);
    font-weight: 500;
    margin-bottom: 0.35rem;
  }

  input:not([type="checkbox"]) {
    margin: 0.45rem 0;
    border-radius: var(--radius);
    min-height: 46px;
  }
}

.signin-hint {
  font-size: 1rem;
  color: #3d3830;
  margin: 0 0 1rem;
}

.signin-help {
  margin: 0.35rem 0 0.85rem;
  font-size: 0.88rem;
}

.signin-card a,
.signin-card a.nav-link,
.signin-card .btn-link,
.signin-card .signin-help a,
.signin-card .signin-footer a {
  color: #6f5729 !important;
  font-weight: 500;
  text-decoration: underline;
}

.signin-card a:hover,
.signin-card a.nav-link:hover,
.signin-card .btn-link:hover,
.signin-card .signin-help a:hover,
.signin-card .signin-footer a:hover {
  color: #1b1712 !important;
}

.signin-body .form-control,
.signin-body .signin-field,
.signin-body input:not([type="checkbox"]) {
  color-scheme: light;
  display: block;
  width: 100%;
  background: #ffffff !important;
  color: #14110e !important;
  border: 2px solid #14110e;
  font-family: "Source Sans 3", "Segoe UI", sans-serif;
  /* 16px matches Chromium autofill so the value does not jump on focus. */
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 1.45;
  padding: 0.7rem 0.75rem;
}

.signin-body .form-control::placeholder,
.signin-body .signin-field::placeholder,
.signin-body input::placeholder {
  color: #3d3830;
  opacity: 1;
  font-size: 16px;
}

.signin-body .form-control:-webkit-autofill,
.signin-body .signin-field:-webkit-autofill,
.signin-body input:-webkit-autofill {
  -webkit-text-fill-color: #14110e;
  caret-color: #14110e;
  box-shadow: 0 0 0 1000px #ffffff inset;
}

.signin-remember,
.signin-check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin: 0.7rem 0 0.85rem;
  color: #1b1712;
  font-weight: 400;
  cursor: pointer;
  user-select: none;
}

.signin-remember input[type="checkbox"],
.signin-check input[type="checkbox"] {
  margin: 0;
  min-height: 0;
  width: 1.05rem;
  height: 1.05rem;
  flex: 0 0 auto;
  accent-color: var(--metal);
}

.signin-submit {
  margin: 0.25rem 0 0.5rem;
  width: 100%;
  background: #1b1712 !important;
  color: #f3eee6 !important;
  border: 1px solid #1b1712 !important;
  border-radius: var(--radius);
  font-weight: 600;
  padding: 0.7rem 1rem;
}

.signin-submit:hover {
  background: #6f5729 !important;
  border-color: #6f5729 !important;
  color: #f3eee6 !important;
}

.signin-submit--alt {
  background: var(--ink);
}

.signin-footer {
  position: relative;
  font-size: 0.85rem;
  margin: 1.25rem 0 0;
  padding: 0;
  width: 100%;

  p { margin: 0; color: #5a5348; }
}

html[data-theme="dark"] .signin-card img,
html[data-theme="dark"] .signin-logo {
  filter: none;
}

.general {
  position: relative;
  gap: 5px;
}

.general label {
  background: transparent;
  color: black;
}

.general label input {
  visibility: hidden !important;
  position: absolute !important;
}
</style>
